<template>
  <div class="finish container">
    <video muted playsinline class="freeze-video" ref="freezeVideo">
      <source src="@/assets/videos/freeze.mp4" type="video/mp4" />
      Your browser does not support HTML5 video.
    </video>
    <div class="box">
      <div align="center" class="appear claims">
        <img src="@/assets/images/logo_jaegermeister.png" class="logo" />
        <div
          class="player-name is-text-orange is-uppercase is-text-bold is-size-large"
        >
          {{ lost }}
        </div>
        <img :src="winnerImage" class="winning-claim" />
        <img
          src="@/assets/images/drink_responsibly.svg"
          class="drink-responsibly"
        />
      </div>

      <div class="shots">
        <div class="move-in-shot left">
          <img :src="glassImage" class="shot" />
        </div>
        <div class="move-in-shot right">
          <img :src="glassImage" class="shot" />
        </div>
      </div>

      <div class="bottom-set">
        <div
          v-if="gamesPlayed < 2"
          class="button move-in-from-bottom"
          @click="goToChooseName()"
        >
          {{ $t("finish.cta") }}
        </div>
        <div class="button move-in-from-bottom" @click="goToEnding()">
          {{ $t("finish.cta_end") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useGameTracking } from "@/composables/useGameTracking";

export default {
  props: {
    lost: {
      type: String,
    },
    finish: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    glassImage() {
      const glassColor = this.$store.state.glassColor;
      return require(`@/assets/images/ice_cold_shot_${glassColor}.png`);
    },
    gamesPlayed() {
      return this.$store.state.gamesPlayed;
    },
    winnerImage() {
      const lang = this.$store.state.language;
      return require(`@/assets/images/winner_text_${lang}.svg`);
    },
  },
  methods: {
    async goToChooseName() {
      this.clickSound.play();
      
      // Track step change back to chooseName
      const { kpiTracker, session } = useGameTracking();
      try {
        await session.updateSessionProgress(kpiTracker.getKpiData(), {
          step: "chooseName",
        });
      } catch (error) {
        console.error("Error updating session for chooseName step:", error);
      }
      
      this.currentStep = "chooseName";
    },
    async goToEnding() {
      this.clickSound.play();
      if (this.gamesPlayed > 1) {
        // Track step change to exit
        const { kpiTracker, session } = useGameTracking();
        try {
          await session.updateSessionProgress(kpiTracker.getKpiData(), {
            step: "exit",
          });
        } catch (error) {
          console.error("Error updating session for exit step:", error);
        }
        
        this.currentStep = "exit";
      } else {
        // Track step change back to prologue
        const { kpiTracker, session } = useGameTracking();
        try {
          await session.updateSessionProgress(kpiTracker.getKpiData(), {
            step: "prologue",
          });
        } catch (error) {
          console.error("Error updating session for prologue step:", error);
        }
        
        this.prologueStep = "intro";
        this.currentStep = "prologue";
      }
    },
  },
  watch: {
    finish() {
      if (this.finish) {
        this.freezeSound.play();
        const video = this.$refs.freezeVideo;
        video.play();
      }
    },
  },
};
</script>

<style lang="sass" scoped>
@import "@/assets/sass/abstracts/variables"
.finish
  position: relative
  .freeze-video
    z-index: 1
    object-fit: fill
    height: 100%
    width: 100%

  .claims
    margin-top: -1rem
    height: 50%

    .logo
      height: 20%
      width: auto

  .appear
    opacity: 0
    animation: appear .5s ease-in forwards 1s

  .winning-claim
    height: 40%
    display: block

  .drink-responsibly
    height: 2%
    margin-top: 1rem
    display: block

  .shots
    position: absolute
    left: 0
    right: 0
    bottom: 15rem
    height: 30%
    text-align: center

    .move-in-shot
      position: relative
      display: inline-block
      height: 100%
      transform: translateX(100rem)
      margin: -2rem
      &.left
        animation: moveInRight 1.5s ease-in forwards 1.5s
      &.right
        animation: moveInRight 1.5s ease-in forwards 2s
      .shot
        height: 100%

  .move-in-from-bottom
    transform: translateY(70rem)
    animation: moveInFromBottom 2s ease-in forwards 2s

@keyframes moveInRight
  0%
    opacity: 0

  100%
    opacity: 1
    transform: translateX(0rem)

@keyframes moveInFromBottom
  0%
    opacity: 0

  100%
    opacity: 1
    transform: translateY(0rem)

@keyframes appear
  0%
    opacity: 0
  100%
    opacity: 1
</style>
